import axiosClient from '../utils/API'
import React, {useState, useEffect, useContext} from 'react'
import {Link, useHistory} from 'react-router-dom'
import {ContextApp} from '../context/ContextApp'

import Spinner from './Spinner'

const Stores = () => {
  const contextApp = useContext(ContextApp)
  const {allProviders, getAllProviders} = contextApp

  const topProvider = allProviders.filter(providers => providers.id > 0)
  const [categories, setCategories] = useState([])

  const [providers, setProviders] = useState([])
  const [nextUrl, setNextUrl] = useState(null)
  const [loading, setLoading] = useState(false)
  async function getProviders() {
    const response = await axiosClient.get('/providers_front')
    setProviders(response.data.data);
    setNextUrl(response.data.meta.next_page);
  }

  async function getMoreProviders() {
    setLoading(true)
    try {
      const response = await axiosClient.get(nextUrl)
      console.log(response);
      setProviders([...providers].concat(response.data.data));
      setNextUrl(response.data.meta.next_page);
      setLoading(false)
    } catch (error) {
      
    }
  }

  useEffect(() => {
    getAllProviders()
    getProviders()
  }, [])
  
  return (
    <div className="container">
      <div id="primary" className="content-area">
        <main id="main" className="site-main">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h4 className="title_stores_unik">Todas las tiendas</h4>
              </div>
              <div className="col-md-12 d-flex flex-wrap justify-content-center">
                {providers?.length === 0 ? (
                  <Spinner />
                ) : (
                  providers?.map((provider, index) => {
                    return (
                      <>
                        <Link
                          to={`/store/company/${provider.slug}/${provider.id}`}
                          class="font-size-12 text-gray-5"
                        >
                          <div className="provider_item_wrapper_card_store">
                            <div className="store_bg_unik">
                              <img src={provider.logo} alt=""/>
                            </div>

                            <div className="store_principal_info">
                              <div className="store_information_unik">
                                <img src={provider.logo} alt=""/>
                                <div>
                                  <h4>{provider.name}</h4>
                                  <a href="#">Ver productos</a>
                                </div>
                              </div>
                              <div className="store_tagas_unik">
                                {provider.categories.length === 0 ? (
                                  provider.aeromall_categories.slice(0,3).map(category => (                                  
                                    <Link to={{
                                      pathname: `/store/company/${provider.slug}/${provider.id}`,
                                      state: category.url                                  
                                    }}>
                                      <span>{category.name}</span>                                
                                    </Link>
                                  ))
                                ) : (
                                  provider.categories.slice(0,3).map(category => (                                  
                                    <Link to={{
                                      pathname: `/store/company/${provider.slug}/${provider.id}`,
                                      state: category.url                                  
                                    }}>
                                      <span>{category.name}</span>                                
                                    </Link>
                                  ))
                                )}                                
                              </div>
                            </div>
                            {!provider.is_new ? null : (
                              <div className="store_brand_new_unik">
                                <span>Nuevo en Aeromall</span>
                              </div>
                            ) }                            
                          </div>
                        </Link>
                      </>
                    )
                  })
                )}
                {providers.length > 0 && 
                  <button 
                    className="more-providers-btn" 
                    onClick={() => getMoreProviders()}>
                      {loading ? 'Cargando...' : 'Más proveedores'}
                  </button> }
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  )
}

export default Stores
